import Header from '../Header/Header.jsx';
import NavigationTabs from '../NavigationTabs/NavigationTabs.jsx';
import Footer from '../Footer/Footer.jsx';

/**
 * GenCRM Layout - composicao das 7 camadas GenApps
 * header(100) / navigation(56) / page-header(80) / page-filters(48 opc) / main / content / footer(40)
 */
const Layout = ({ user, tabs, activeTab, onTabChange, title, subtitle, filters, actions, children }) => {
  return (
    <div className={`gencrm_app ${filters ? '' : 'gencrm_app--no-filters'}`}>
      <Header user={user} />
      <NavigationTabs tabs={tabs} activeTab={activeTab} onTabChange={onTabChange} />

      <div className="gencrm_app__page-header">
        <div className="gencrm_app__page-header-left">
          <div className="gencrm_app__page-header-title">{title}</div>
          {subtitle && <div className="gencrm_app__page-header-subtitle">{subtitle}</div>}
        </div>
        <div className="gencrm_app__page-header-actions">{actions}</div>
      </div>

      {filters && <div className="gencrm_app__page-filters">{filters}</div>}

      <main className="gencrm_app__main">
        <div className="gencrm_app__content">{children}</div>
      </main>

      <Footer />
    </div>
  );
};

export default Layout;
